import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';
import { NbToastrService } from '@nebular/theme';
import { plainToClass } from 'class-transformer';
import { User } from '../../shared/data/user';
import { ApiService } from '../../shared/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';


@Component({
  template: `
  <div class="col-sm-12" *ngIf="authService.token.user.id !== user.id">
    <nb-toggle [(ngModel)]="value" name="status" (click)="publish()">Activer</nb-toggle>
  </div>
  `,
})
export class ActiveRenderComponent implements ViewCell, OnInit {

  renderValue: number;

  @Input() value: number;
  @Input() rowData: any;

  user: User;


  constructor( public toastr:NbToastrService, private apiService:ApiService, private router:Router, public authService: AuthService) {
  }

  ngOnInit() {
    // this.renderValue = this.value.toString().toUpperCase();
    this.renderValue = this.value;
    this.user = plainToClass( User, this.rowData as object);

  }

  publish() {
    /* console.log( this.rowData );
    if( !this.value )
    this.toastr.success('Activé', this.user.username);
    else
    this.toastr.success('Déactivé', this.user.username); */

    let val = false;
    console.log( this.rowData );
    if( !this.value )
    this.user.is_active = true
    // this.toastr.success('Publié(e)', this.pub.titre);
    else
    this.user.is_active = false
    // this.toastr.success('depublié(e)', this.pub.titre);


    this.apiService.activeUserProvider(this.user).subscribe(data =>{

      if( this.value )
      this.toastr.success('Activé', this.user.username);
      else
      this.toastr.success('Déactivé', this.user.username);
     
    },(err) =>{

      // this.value = !this.value
    
      this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
      
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
        
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })

  }

}
